export const IMPERSONATED_FROM_PATH_NAME = 'impersonatedFromPath';

export const IMPERSONATED_FROM_COMPANY_ID = 'impersonatedFromCompanyId';

export const LS_REDIRECT_URL = 'lsRedirectUrl';

export const LS_ACCOUNTS_COMPANY_ID = 'lsAccountsCompanyId';
export const LS_ACCOUNTS_CLIENT_ID = 'lsAccountsClientId';
export const IS_REFRESHING_IN_OTHER_TAB = 'isRefreshingInOtherTab';

export const LS_DOMAIN_NAME = 'lsDomainName';

// The TPO-signup origin a cert partner was handed off from, so a later session timeout on the
// cert surface can bounce the passwordless partner back to that host's OTP login. Deliberately
// excluded from the reset-on-logout lists below — it must survive the logout that triggers the
// redirect that reads it.
export const LS_TPO_CERT_SIGNUP_HOST = 'lsTpoCertSignupHost';

export const ACTIVITIES_FILTER_LS_KEY = 'activitiesFilter';

export const BlockSizesLocalStorageKey = {
  RULES: 'rules',
  ELIGIBIILITY_BUILDER: 'eligibilityBuilder',
  MI_RULES: 'miRules',
  RATE_LOCK_TERMS: 'rateLockTerms',
  ESCROW_REQUIREMENTS: 'escrowRequirements',
  ADJUSTMENTS: 'adjustments',
  APPRAISAL_PRODUCT: 'appraisalProduct',
  TASK_CATEGORIES: 'taskCategories',
  TPO_DENIAL_CONFIGURATION: 'tpoDenialConfiguration',
  LOAN_ACTIONS: 'loanActions',
  DOCUMENT_FIELD_TYPES: 'documentFieldTypes',
  DOCUMENT_EXTRACTION_FIELDS: 'documentExtractionFields',
  DOCUMENT_EXTRACTION_FIELDS_MAPPING: 'documentExtractionFieldsMapping',
  CALCULATION_FIELDS: 'calculationFields',
  LOAN_ROLE_ASSIGNMENT: 'loanRoleAssignment',
  PIPELINES: 'pipelines',
  APPLY_FORM_CUSTOM_QUESTIONS: 'applyFormCustomQuestions',
  LOAN_TAG_ASSIGNMENT: 'loanTagAssignment',
  LLPA_CAPS: 'llpaCaps',
  MI_COVERAGE_CRITERIA: 'miCoverageCriteria',
  FEE_PROVIDERS: 'feeProviders',
  AUTOMATED_ACTION_CRITERIA: 'automatedActionCriteria',
  CHECKLISTS: 'checklists',
  FORM_BUNDLES_AFTER_SUBMIT: 'formBundlesAfterSubmit',
  AUTO_LOCK_RULES: 'autoLockRules',
  DOCUMENTS_LIST_COLLAPSED: 'documentsListCollapsed',
  DOCUMENTS_INSPECTOR_COLLAPSED: 'documentsInspectorCollapsed',
};

export const LOAN_PIPELINES_PING_SERVER_TIMESTAMP_KEY = 'loanPipelinesPingServerTimestamp';

export const LS_IS_HEADER_COLLAPSED = 'isLoanHeaderCollapsed';

export const LS_KEYS_TO_RESET_ON_LOGOUT = [
  ACTIVITIES_FILTER_LS_KEY,
  LS_IS_HEADER_COLLAPSED,
  LS_ACCOUNTS_CLIENT_ID,
];

export const LS_KEYS_TO_RESET_ON_LOGOUT_EXPLICIT = [
  ACTIVITIES_FILTER_LS_KEY,
  LS_IS_HEADER_COLLAPSED,
  LS_REDIRECT_URL,
  LS_ACCOUNTS_CLIENT_ID,
];
